import { SxProps, Typography, TypographyProps } from '@mui/material';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';

interface Props extends TypographyProps {
  text: string;
}

const sxStyle: SxProps = {
  fontFamily: "UnimedSans-Bold",
  fontSize: "14px",
  fontWeight: "700",
  lineHeight: "30px",
  letterSpacing: "0em",
  textAlign: "left",
  color: "#4C4C4C",
  textWrap: 'wrap',
}

const TableBold: React.FC<Props> = ({ text, ...typographyProps }) => {

  const accessibility = useAccessibility();

  return (
    <Typography
      sx={sxStyle}
      style={accessibility.textStyleAccessibility}
      tabIndex={0}
      dangerouslySetInnerHTML={{ __html: text }}
      {...typographyProps}
    />
  )
}

export default TableBold;